(function () {
  var COLLECTION_CACHE_TTL_MS = 15 * 60 * 1000;
  var COLLECTION_PAGE_SIZE = 250;

  function normalizePrice(value) {
    if (typeof value === 'number') {
      if (value > 100000) return value / 100.0;
      return value;
    }

    if (typeof value === 'string') {
      var parsed = parseFloat(value);
      if (Number.isNaN(parsed)) return 0;
      if (/^\d+$/.test(value)) return parsed / 100.0;
      return parsed;
    }

    return 0;
  }

  function getProductType(product) {
    return product.product_type || product.type || '';
  }

  function getPublishedAt(product) {
    return product.published_at || product.publishedAt || '';
  }

  function getSalesRank(product) {
    if (typeof product.salesRank === 'number') return product.salesRank;
    if (typeof product.sales_rank === 'number') return product.sales_rank;
    var maybe = parseFloat(product.salesRank || product.sales_rank || 0);
    return Number.isNaN(maybe) ? 0 : maybe;
  }

  function toComparableProduct(raw, position) {
    var firstVariant = raw.variants && raw.variants.length ? raw.variants[0] : null;

    return {
      id: String(raw.id),
      handle: raw.handle || '',
      title: raw.title || '',
      vendor: raw.vendor || '',
      productType: getProductType(raw),
      price: normalizePrice(raw.price != null ? raw.price : firstVariant && firstVariant.price),
      publishedAt: getPublishedAt(raw),
      position: Number(raw.position || position || 0),
      salesRank: getSalesRank(raw),
    };
  }

  function createStorageKey(handle) {
    return 'st_collection_payload_' + handle;
  }

  function canUseSessionStorage() {
    try {
      var key = '__st_collection_sort_probe__';
      sessionStorage.setItem(key, '1');
      sessionStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  function CollectionSorter() {
    this.products = [];
    this.productsById = {};
    this.currentSort = 'manual';
    this.suppressHistory = false;
    this.collectionHandle = null;
    this.supportedSorts = {
      manual: true,
      featured: true,
      'price-asc': true,
      'price-ascending': true,
      'price-desc': true,
      'price-descending': true,
      'best-selling': true,
      newest: true,
      'created-descending': true,
      oldest: true,
      'created-ascending': true,
      'title-asc': true,
      'title-ascending': true,
      'title-desc': true,
      'title-descending': true,
    };

    this.grid = null;
    this.sortSelect = null;

    this.init();
  }

  CollectionSorter.prototype.readInlinePayload = function () {
    var dataEl = document.getElementById('collection-products-data');
    if (!dataEl) return null;

    try {
      return JSON.parse(dataEl.textContent || '{}');
    } catch (e) {
      console.error('[CollectionSorter] Failed to parse inline product data', e);
      return null;
    }
  };

  CollectionSorter.prototype.init = function () {
    var payload = this.readInlinePayload();
    if (!payload) return;

    this.collectionHandle = payload.collection && payload.collection.handle;
    this.products = (payload.products || []).map(function (product, index) {
      return toComparableProduct(product, index + 1);
    });
    this.indexProducts();

    this.grid = document.getElementById('product-grid') || document.querySelector('[data-product-grid]');
    this.sortSelect = document.getElementById('SortBy') || document.querySelector('[data-sort-by]');

    this.bindSortEvents();
    this.bindPopState();
    this.bindFacetRefresh();
    this.maybeApplyPersonalization();
    this.applySortFromURL();

    if (this.collectionHandle) {
      this.loadAllCollectionProducts().catch(function (err) {
        console.warn('[CollectionSorter] Background collection load skipped', err);
      });
    }
  };

  CollectionSorter.prototype.indexProducts = function () {
    this.productsById = {};
    for (var i = 0; i < this.products.length; i += 1) {
      this.productsById[this.products[i].id] = this.products[i];
    }
  };

  CollectionSorter.prototype.bindSortEvents = function () {
    var self = this;
    if (!this.sortSelect) return;
    if (this.sortSelect.dataset.clientSorterBound === '1') return;

    this.sortSelect.dataset.clientSorterBound = '1';

    this.sortSelect.addEventListener(
      'change',
      function (event) {
        var method = event.target.value;
        if (!self.isClientSort(method)) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        self.sort(method);
      },
      true
    );

    var sortForm = this.sortSelect.closest('form');
    if (sortForm) {
      sortForm.addEventListener('submit', function (event) {
        if (self.isClientSort(self.sortSelect.value)) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  };

  CollectionSorter.prototype.bindPopState = function () {
    var self = this;
    if (this._popStateBound) return;
    this._popStateBound = true;

    window.addEventListener('popstate', function () {
      self.applySortFromURL();
    });
  };

  CollectionSorter.prototype.bindFacetRefresh = function () {
    var self = this;
    if (this._facetRefreshBound) return;
    this._facetRefreshBound = true;

    document.addEventListener('facets:updated', function () {
      self.reinitializeFromDOM();
    });

    document.addEventListener('shopify:section:load', function () {
      self.reinitializeFromDOM();
    });
  };

  CollectionSorter.prototype.isClientSort = function (method) {
    return !!this.supportedSorts[method];
  };

  CollectionSorter.prototype.applySortFromURL = function () {
    var params = new URLSearchParams(window.location.search);
    var method = params.get('sort_by') || 'manual';

    if (!this.isClientSort(method)) return;

    this.suppressHistory = true;
    this.sort(method);
    this.suppressHistory = false;

    if (this.sortSelect) {
      this.sortSelect.value = method;
    }
  };

  CollectionSorter.prototype.updateURL = function (method) {
    if (this.suppressHistory) return;

    var url = new URL(window.location.href);

    if (method === 'manual' || method === 'featured') {
      url.searchParams.delete('sort_by');
    } else {
      url.searchParams.set('sort_by', method);
    }

    window.history.pushState({}, '', url.toString());
  };

  CollectionSorter.prototype.sort = function (method) {
    var sorted = this.products.slice();

    switch (method) {
      case 'manual':
      case 'featured':
        sorted.sort(function (a, b) {
          return a.position - b.position;
        });
        break;
      case 'price-asc':
      case 'price-ascending':
        sorted.sort(function (a, b) {
          return a.price - b.price;
        });
        break;
      case 'price-desc':
      case 'price-descending':
        sorted.sort(function (a, b) {
          return b.price - a.price;
        });
        break;
      case 'best-selling':
        sorted.sort(function (a, b) {
          return b.salesRank - a.salesRank;
        });
        break;
      case 'newest':
      case 'created-descending':
        sorted.sort(function (a, b) {
          return new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime();
        });
        break;
      case 'oldest':
      case 'created-ascending':
        sorted.sort(function (a, b) {
          return new Date(a.publishedAt).getTime() - new Date(b.publishedAt).getTime();
        });
        break;
      case 'title-asc':
      case 'title-ascending':
        sorted.sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
        break;
      case 'title-desc':
      case 'title-descending':
        sorted.sort(function (a, b) {
          return b.title.localeCompare(a.title);
        });
        break;
      default:
        return;
    }

    this.currentSort = method;
    this.renderProducts(sorted);
    this.updateURL(method);

    document.dispatchEvent(
      new CustomEvent('collection:sorted', {
        detail: {
          method: method,
          productCount: sorted.length,
        },
      })
    );
  };

  CollectionSorter.prototype.renderProducts = function (products) {
    if (!this.grid) return;

    var nodeMap = {};
    var children = this.grid.children;

    for (var i = 0; i < children.length; i += 1) {
      var child = children[i];
      if (!child || !child.dataset || !child.dataset.productId) continue;
      nodeMap[String(child.dataset.productId)] = child;
    }

    var desiredOrder = [];
    for (var d = 0; d < products.length; d += 1) {
      var desiredId = String(products[d].id);
      if (nodeMap[desiredId]) {
        desiredOrder.push(desiredId);
      }
    }

    var currentOrder = [];
    for (var c = 0; c < children.length; c += 1) {
      var current = children[c];
      if (!current || !current.dataset || !current.dataset.productId) continue;
      currentOrder.push(String(current.dataset.productId));
    }

    if (desiredOrder.length === currentOrder.length) {
      var unchanged = true;
      for (var o = 0; o < desiredOrder.length; o += 1) {
        if (desiredOrder[o] !== currentOrder[o]) {
          unchanged = false;
          break;
        }
      }
      if (unchanged) return;
    }

    var fragment = document.createDocumentFragment();

    for (var p = 0; p < products.length; p += 1) {
      var productNode = nodeMap[products[p].id];
      if (productNode) {
        if (productNode.classList && productNode.classList.contains('scroll-trigger')) {
          productNode.classList.add('scroll-trigger--cancel');
        }
        fragment.appendChild(productNode);
      }
    }

    this.grid.appendChild(fragment);
  };

  CollectionSorter.prototype.getCachedCollectionProducts = function () {
    if (!this.collectionHandle || !canUseSessionStorage()) return null;

    var raw = sessionStorage.getItem(createStorageKey(this.collectionHandle));
    if (!raw) return null;

    try {
      var parsed = JSON.parse(raw);
      if (!parsed.timestamp || !parsed.products) return null;
      if (Date.now() - parsed.timestamp > COLLECTION_CACHE_TTL_MS) return null;
      return parsed.products;
    } catch (e) {
      return null;
    }
  };

  CollectionSorter.prototype.setCachedCollectionProducts = function (products) {
    if (!this.collectionHandle || !canUseSessionStorage()) return;

    try {
      sessionStorage.setItem(
        createStorageKey(this.collectionHandle),
        JSON.stringify({
          timestamp: Date.now(),
          products: products,
        })
      );
    } catch (e) {
      // Ignore cache failures.
    }
  };

  CollectionSorter.prototype.loadAllCollectionProducts = async function () {
    var cached = this.getCachedCollectionProducts();
    if (cached && cached.length) {
      this.applyHydratedProducts(cached);
      return;
    }

    if (!this.collectionHandle) return;

    var allProducts = [];
    var page = 1;

    while (true) {
      var endpoint = '/collections/' + encodeURIComponent(this.collectionHandle) + '/products.json?limit=' + COLLECTION_PAGE_SIZE + '&page=' + page;
      var resp = await fetch(endpoint, { credentials: 'same-origin' });

      if (!resp.ok) {
        throw new Error('Failed to load ' + endpoint + ' (' + resp.status + ')');
      }

      var json = await resp.json();
      var pageProducts = (json && json.products) || [];

      if (!pageProducts.length) break;

      allProducts = allProducts.concat(pageProducts);

      if (pageProducts.length < COLLECTION_PAGE_SIZE) {
        break;
      }

      page += 1;
    }

    if (!allProducts.length) return;

    this.setCachedCollectionProducts(allProducts);
    this.applyHydratedProducts(allProducts);
  };

  CollectionSorter.prototype.applyHydratedProducts = function (products) {
    var indexById = {};
    for (var i = 0; i < this.products.length; i += 1) {
      indexById[this.products[i].id] = this.products[i].position;
    }

    var normalized = products.map(function (product, idx) {
      var id = String(product.id);
      return toComparableProduct(product, indexById[id] || idx + 1);
    });

    normalized.sort(function (a, b) {
      return a.position - b.position;
    });

    this.products = normalized;
    this.indexProducts();

    if (this.currentSort && this.isClientSort(this.currentSort)) {
      this.sort(this.currentSort);
    }
  };

  CollectionSorter.prototype.maybeApplyPersonalization = function () {
    if (!window.personalizationScorer || !window.personalizationScorer.isAvailable()) {
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var sortFromUrl = params.get('sort_by');
    if (sortFromUrl) return;

    var personalizedProducts = window.personalizationScorer.personalizeOrder(this.products, 0.7);
    this.products = personalizedProducts;
    this.indexProducts();

    if (this.currentSort === 'manual' || this.currentSort === 'featured') {
      this.renderProducts(this.products);
    }
  };

  CollectionSorter.prototype.reinitializeFromDOM = function () {
    var payload = this.readInlinePayload();
    if (!payload) return;

    this.collectionHandle = payload.collection && payload.collection.handle;
    this.products = (payload.products || []).map(function (product, index) {
      return toComparableProduct(product, index + 1);
    });
    this.indexProducts();

    this.grid = document.getElementById('product-grid') || document.querySelector('[data-product-grid]');
    this.sortSelect = document.getElementById('SortBy') || document.querySelector('[data-sort-by]');

    this.bindSortEvents();

    if (this.sortSelect && this.currentSort) {
      this.sortSelect.value = this.currentSort;
    }

    if (this.currentSort && this.isClientSort(this.currentSort)) {
      this.suppressHistory = true;
      this.sort(this.currentSort);
      this.suppressHistory = false;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.collectionSorter = new CollectionSorter();
    });
  } else {
    window.collectionSorter = new CollectionSorter();
  }
})();
